<template>

    <div>

        <div class="row g-4">

            <div class="col-lg-8">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Seiteninhalt') }}</legend>
                            <!--@todo parent_id-->
                            <text-input label="Titel" v-model="form.title" :error="form.errors.title" />
                            <text-input label="slug" v-model="form.slug" :error="form.errors.slug" />
                            <textarea-input label="content" v-model="form.content" :error="form.errors.content" rows="20" class-name="text-nowrap font-monospace" />
                        </fieldset>
                    </div>
                </div>
            </div>
            <div class="col-lg-4">

                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Settings') }}</legend>
                            <!-- @todo <checkbox-input label="visible_to_logged_in_users_only" v-model="form.visible_to_logged_in_users_only" :error="form.errors.visible_to_logged_in_users_only" />-->
                            <div class="row row-cols-2">
                                <div class="col">
                                    <select-input label="publish_status" v-model="form.publish_status" :error="form.errors.publish_status">
                                        <option :value="k" v-for="(v, k) in publishStatusOptions">{{ v }}</option>
                                    </select-input>
                                </div>
                                <div class="col"></div>
                                <div class="col">
                                    <text-input type="datetime-local" label="publish_from" v-model="form.publish_from" :error="form.errors.publish_from" />
                                </div>
                                <div class="col">
                                    <text-input type="datetime-local" label="publish_until" v-model="form.publish_until" :error="form.errors.publish_until" />
                                </div>
                            </div>
                            <select-input label="template" v-model="form.template" :error="form.errors.template">
                                <option :value="null">{{ __('Default') }}</option>
                                <option :value="k" v-for="(v, k) in templateOptions">{{ v }}</option>
                            </select-input>
                        </fieldset>
                        
                        <hr />

                        <fieldset>
                            <legend>{{ __('SEO') }}</legend>
                            <text-input label="Meta-Robots" v-model="form.meta_robots" :error="form.errors.meta_robots" />
                            <text-input label="Meta-Title" v-model="form.meta_title" :error="form.errors.meta_title" />
                            <textarea-input label="Meta-Description" v-model="form.meta_description" :error="form.errors.meta_description" />
                        </fieldset>

<!--                       @todo <fieldset>
                            <legend>{{ __('Vorschaubild') }}</legend>
                            <attachment-selector v-model="form.image_id" :error="form.errors.image_id" max="1" />
                        </fieldset>-->
                    </div>
                </div>

            </div>

            <div class="d-flex align-items-center w-100">
                <submit-button :form="form" />
                <button type="button" class="btn link-danger" @click="destroy" v-if="page">
                    {{ __('Put in trash') }}
                </button>
            </div>

        </div>

    </div>

</template>

<script>
    import TextInput from '@/shared/Inputs/TextInput';
    import SelectInput from '@/shared/Inputs/SelectInput';
    import TextareaInput from '@/shared/Inputs/TextareaInput';
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';
    import FileInput from '@/shared/Inputs/FileInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';
    import AttachmentSelector from '@/shared/Inputs/AttachmentSelector';
    import EditorInput from '@/shared/Inputs/EditorInput';

    export default {
        props: [
            'form',
            'page',
            'templateOptions',
            'publishStatusOptions',
        ],
        data() {
            return {

            }
        },
        components: {
            TextInput,
            SelectInput,
            TextareaInput,
            CheckboxInput,
            FileInput,
            SubmitButton,
            EditorInput,
            AttachmentSelector,
        },
        watch: {
        },
        methods: {
            destroy() {
                this.$inertia.delete(this.route('admin.pages.destroy', this.page));
            },
        },
    }
</script>
